import React, { useEffect, useState } from "react";

import { AssigneeContainer } from "./styled";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganizationResponsibleUsers,
  setFeedbackAssignee,
} from "state/modules/organization";
import DropDownPicker from "react-native-dropdown-picker";

export const AssigneeQuestion = ({ question }) => {
  const dispatch = useDispatch();
  const questionnaire_id = useSelector(state => state.survey.questionnaireId);

  useEffect(() => {
    dispatch(getOrganizationResponsibleUsers(questionnaire_id));
  }, [dispatch, questionnaire_id]);

  const [is_open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [items, setItems] = useState([]);

  const responsibleUsers = useSelector(
    state => state.organization.responsibleUsers,
  );

  useEffect(() => {
    const users = responsibleUsers.map(responsibleUser => ({
      label: responsibleUser.full_name,
      value: responsibleUser.id,
    }));
    setItems(users);
  }, [responsibleUsers]);

  return (
    <AssigneeContainer>
      <DropDownPicker
        open={is_open}
        value={value}
        multiple={false}
        items={items}
        setOpen={setOpen}
        setValue={setValue}
        setItems={setItems}
        searchable={true}
        placeholder="Select Assignee"
        searchPlaceholder="Search..."
        onSelectItem={assignee_id => {
          dispatch(setFeedbackAssignee(assignee_id));
        }}
      />
    </AssigneeContainer>
  );
};
